export enum TypeConceptEnums {
  entrada = 1,
  salida = 2,
  tipoNegocio = 3,
  tipoVehiculo = 4,
  subalquiler = 5,
  notaCredito = 6,
  notaDebito = 7,
  anulacion = 8,
  tipoFacturaDIAN = 9,
  medioDePagoDIAN = 10,
  tipoNegocio2 = 11,
  tipoEquipo = 12

}
